var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"z-image"},[_c('top-bar',{on:{"topBarEvent":_vm.topBarEvent}}),_c('div',{ref:"view",staticClass:"view",style:({
      'justify-content': _vm.rowAlign,
      'align-items': _vm.colAlign
    }),attrs:{"id":"view"}},[_c('div',{staticClass:"cover"}),_c('img',{staticClass:"image",attrs:{"src":_vm.src}})]),_c('v-overlay',{attrs:{"absolute":true,"opacity":.8,"value":_vm.overlay}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }